/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import { EstablishmentConfigPropType, ScheduleDataPropType } from "./types";

const defaultSchedule: ScheduleDataPropType[] = Array.from({ length: 7 }, (_, index) => {
  const day = index + 1;
  return{
  id: `${day}`, // Unique ID for each day
  establishment_id: "default", // Placeholder establishment ID
  day, // Day of the week (0 = Sunday, 1 = Monday, etc.)
  opening_time: "00:00:00",
  closing_time: "00:00:00",
  created_at: "",
  updated_at: "",
  }
});

const initialStateValue: EstablishmentConfigPropType = {
  schedule: defaultSchedule,
  scheduleLoading: true,
};

export const establishmentconfigSlice = createSlice({
  name: "establishmentconfig",
  initialState: { value: initialStateValue },
  reducers: {
    setEstablishmentconfig: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },

    resetEstablishmentconfig: (state) => {
      state.value = initialStateValue;
    },
  },
});

export const { setEstablishmentconfig, resetEstablishmentconfig } =
  establishmentconfigSlice.actions;

export default establishmentconfigSlice.reducer;
